import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Cookies from 'js-cookie'

import { FR } from './fr'
import { EN } from './en'
import { HE } from './he'
import { ES } from './es'
import { WhitelabelConfig } from 'hooks'

export const Languages = [
    {
        id: 'en',
        name: 'English',
        disabled: WhitelabelConfig.englishLanguageDiabled
    },
    {
        id: 'fr',
        name: 'Français',
        disabled: WhitelabelConfig.frenchLanguageDiabled
    },
    {
        id: 'he',
        name: 'עִברִית',
        disabled: WhitelabelConfig.hebrewLanguageDiabled
    },{
        id: 'es',
        name: 'Español',
        disabled: WhitelabelConfig.spanishLanguageDisabled
    }
]

const setRTL = (lang) => {
    lang === 'he' ? (document.documentElement.dir = 'rtl') : document.documentElement.removeAttribute('dir')
}

const languageChange = (lang) => {
    document.documentElement.setAttribute('lang', lang)
    setRTL(lang)
}

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: EN
            },
            fr: {
                translation: FR
            },
            he: {
                translation: HE
            },
            es: {
                translation: ES
            }
        },
        supportedLngs: ['en', 'fr', 'he', 'es'],
        fallbackLng: 'en'
    })
    .then(() => languageChange(i18n.language))

i18n.on('languageChanged', languageChange)

export const setKavkomLanguageCookie = (lang) => {
    Cookies.set('kavkom_language', lang, languageCookieAttributes(lang))
}

const languageCookieAttributes = (val) => {
    const now = new Date()
    const expirationTime = new Date(now.getTime() + yearsToMiliseconds(10)) // Expiration time 10 years from now

    return {
        domain: 'kavkom.com',
        path: '/',
        expires: expirationTime
    }
}

const yearsToMiliseconds = (years) => 3600 * 1000 * 24 * 365 * years
